const storageKey = 'scor.subscriptionConfirmation';

interface SavedConfirmation {
  owner: string;
  savedAt: number;
  data: ApiCreateScorSubscriptionResponseData;
}

export const readSubscriptionConfirmation = (): SavedConfirmation | undefined => {
  try {
    const owner = localStorage.getItem('authSid');
    const saved = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null') as SavedConfirmation | null;
    if (owner && saved?.owner === owner && typeof saved.savedAt === 'number' && saved.data) return saved;
  } catch { /* Storage may be unavailable. Server state remains authoritative. */ }

  return undefined;
};

export const saveSubscriptionConfirmation = (data: ApiCreateScorSubscriptionResponseData): number => {
  try {
    const owner = localStorage.getItem('authSid');
    if (owner) {
      const savedAt = Date.now();
      sessionStorage.setItem(storageKey, JSON.stringify({ owner, savedAt, data: { message: data.message, amount: data.amount, plan_period_id: data.plan_period_id, period_label: data.period_label, request_id: data.request_id } }));

      return savedAt;
    }
  } catch { /* Keep the immediate confirmation in React state. */ }

  return 0;
};

export const clearSubscriptionConfirmation = (): void => {
  try { sessionStorage.removeItem(storageKey); } catch { /* Storage may be unavailable. */ }
};
